// extracted by mini-css-extract-plugin
export default {"sorting":"SortingPanel_sorting__8QZIo","highlighted":"SortingPanel_highlighted__x0fjk"};